import React, { useState, useEffect, useRef } from "react";
import { GlobalState } from "../../redux/root-reducer";
import { connect } from "react-redux";
import { User } from "../../@types/user.interface";
import { Dispatch } from "redux";
import { IInsertFeedbackPayload } from "../../redux/feedback/feedback.actions";
import { fetchApi } from "../../redux/fetch/fetch.actions";
import Feedback from "../../@types/feedback.interface";
import { useHistory } from "react-router-dom";
import { validateFeedback } from "../../utils/validation";
import FeedbackForm from "../../components/feedback-form/feedback-form.component";
import Loading from "../../components/loading/loading.component";

interface IProps {
    isFetching?: boolean;
    errors?: string;
    user: User | null;
    insertFeedback: (data: IInsertFeedbackPayload["data"]) => void;
}

function FeedbackContainer({
    isFetching,
    errors,
    user,
    insertFeedback,
}: IProps) {
    const [feedback, setFeedback] = useState<Feedback>({
        feedback_name: "",
        feedback_email: "",
        feedback_description: "",
    });
    const check = useRef(false);
    const history = useHistory();

    useEffect(() => {
        if (isFetching || errors) return;
        if (!isFetching && check.current === true) {
            sessionStorage.setItem("_i", "0");
            history.push("/home");
        }
    }, [isFetching, errors, history]);

    useEffect(() => {
        if (user) {
            setFeedback((prevState) => ({
                ...prevState,
                feedback_email: user.email_address
                    ? user.email_address
                    : user.initial
                    ? user.initial
                    : "",
            }));
        }
    }, [user]);

    const onHandleChange = (evt: any, name: string) => {
        let val = evt.target.value;
        if (name === "name")
            setFeedback((prevState) => ({
                ...prevState,
                feedback_name: val,
            }));
        else if (name === "description")
            setFeedback((prevState) => ({
                ...prevState,
                feedback_description: val,
            }));
    };

    const [error, setError] = useState("");

    const onHandleClick = (evt: any) => {
        evt.preventDefault();
        setError(validateFeedback(feedback));
        if (validateFeedback(feedback) === "") {
            insertFeedback(feedback);
            check.current = true;
        }
    };

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="fixed" />
            ) : (
                <div className="container__content">
                    <FeedbackForm
                        error={error}
                        onHandleChange={onHandleChange}
                        onHandleClick={onHandleClick}
                    />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = ({
    user: {
        self: { data },
    },
    fetchController: { isFetching, errors },
}: GlobalState) => ({
    user: data,
    isFetching: isFetching.INSERT_FEEDBACK,
    erorrs: errors.INSERT_FEEDBACK,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    insertFeedback: (data: IInsertFeedbackPayload["data"]) =>
        dispatch(fetchApi({ name: "INSERT_FEEDBACK", data: data })),
});

const FeedbackPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(FeedbackContainer);

export default FeedbackPage;
